import React, { Component } from 'react';
import MainContainer from './mainContainer';


class MainContent extends Component {
  render() {
    return (
      <MainContainer />
    );
  }
}


export default MainContent;
